import { useStaticQuery, graphql } from "gatsby"

const useAllSitePage = () => {
  // Consultamos todas las paginas creadas en Page y Microsite
  // Quitando los filtros, traemos todas las paginas creadas en el sitio
  const query = useStaticQuery(graphql`
    {
      allSitePage(
        filter: {
          componentChunkName: {
            in: [
              "component---src-templates-microsite-microsite-js"
              "component---src-templates-page-page-js"
              "component---src-templates-novelty-novelty-js"
            ]
          }
        }
      ) {
        nodes {
          path
        }
      }
    }
  `)

  return query
}
export default useAllSitePage
